import plugin from 'tailwindcss/plugin';

export default plugin(({ matchUtilities, theme }) => {
  matchUtilities(
    {
      'animation-duration': (value) => ({
        'animation-duration': value,
      }),
    },
    {
      values: theme('transitionDuration'),
    },
  );
});
